import { useState } from "react";
import { Link } from "react-router-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

const PORTFOLIO = [
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/zli8phi6_fpb%201.png",
    title: "NASPOWER Event Package",
    tag: "Apparel + Canopy",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/vxi07jf0_fpb%203.png",
    title: "Alchemy Jiu Jitsu Rashguard",
    tag: "DTF Printing",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/oqxr1jxb_fpb%206.png",
    title: "Lock and Load Barbell Banner",
    tag: "Large Format",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/6hdi4621_fpb%207.png",
    title: "Custom Awareness Tee",
    tag: "DTF Printing",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/x3aks386_fpb%204.png",
    title: "Battle at the Armory Event Shirt",
    tag: "Screen Printing",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/fqo677lz_fpb%208.png",
    title: "Sisters of Iron Tank Top",
    tag: "Screen Printing",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/3jyfukfy_fpb%209.png",
    title: "Junior's Discount Liquor Signage",
    tag: "Large Format",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/ia1darcf_fpb%205.png",
    title: "Valhalla Competition Gear",
    tag: "Apparel",
  },
  {
    img: "https://customer-assets.emergentagent.com/job_d4287510-3032-43dc-a2e9-61b11f4b1517/artifacts/g4u37nhh_fpb%202.png",
    title: "Alchemy Jiu Jitsu Team Order",
    tag: "DTF Printing",
  },
];

export const Portfolio = () => {
  const [lightbox, setLightbox] = useState(null);

  const openLightbox = (idx) => setLightbox(idx);
  const closeLightbox = () => setLightbox(null);
  const prev = () => setLightbox((i) => (i === 0 ? PORTFOLIO.length - 1 : i - 1));
  const next = () => setLightbox((i) => (i === PORTFOLIO.length - 1 ? 0 : i + 1));

  return (
    <section className="py-16 bg-gray-950" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <p className="text-orange-500 font-semibold text-sm tracking-widest uppercase mb-2">Portfolio</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">Our Work</h2>
          <p className="text-gray-400 mt-2 max-w-lg mx-auto text-sm">Real projects. Real clients. See what Fit Print Bros can do for your brand.</p>
        </div>

        {/* Masonry-style grid */}
        <div className="columns-2 md:columns-3 gap-3 space-y-3">
          {PORTFOLIO.map((item, idx) => (
            <div
              key={item.title}
              className="break-inside-avoid group relative overflow-hidden rounded-lg cursor-pointer"
              onClick={() => openLightbox(idx)}
              data-testid={`portfolio-item-${idx}`}
            >
              <img
                src={item.img}
                alt={item.title}
                className="w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-4">
                <span className="text-xs font-bold text-orange-400 uppercase tracking-wider">{item.tag}</span>
                <span className="text-white font-semibold text-sm">{item.title}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/products"
            className="inline-block px-8 py-3 bg-gradient-to-r from-orange-500 to-red-600 text-white font-bold rounded-full hover:shadow-lg hover:shadow-orange-500/25 transition-all"
            data-testid="portfolio-cta"
          >
            Start Your Project
          </Link>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox !== null && (
        <div className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center p-4" onClick={closeLightbox}>
          <button onClick={(e) => { e.stopPropagation(); closeLightbox(); }} className="absolute top-4 right-4 text-white/70 hover:text-white z-50" data-testid="lightbox-close">
            <X className="w-8 h-8" />
          </button>
          <button onClick={(e) => { e.stopPropagation(); prev(); }} className="absolute left-4 text-white/70 hover:text-white z-50">
            <ChevronLeft className="w-10 h-10" />
          </button>
          <button onClick={(e) => { e.stopPropagation(); next(); }} className="absolute right-4 text-white/70 hover:text-white z-50">
            <ChevronRight className="w-10 h-10" />
          </button>
          <div className="max-w-4xl max-h-[85vh] flex flex-col items-center" onClick={(e) => e.stopPropagation()}>
            <img src={PORTFOLIO[lightbox].img} alt={PORTFOLIO[lightbox].title} className="max-h-[75vh] object-contain rounded-lg" />
            <div className="mt-3 text-center">
              <span className="text-orange-400 text-xs font-bold uppercase tracking-wider">{PORTFOLIO[lightbox].tag}</span>
              <p className="text-white font-semibold mt-1">{PORTFOLIO[lightbox].title}</p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
